// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ListD_TheComp__oZzoS"};